<template>
  <span class="sr-only">
    (opens in a new window or tab)
  </span>
</template>

<script setup>
/**
 * Provide consistent verbiage for screen reader hint when a link is to be launched in a new window/tab.
 */
defineOptions({
  name: 'LinkOpenForSr'
})
</script>